/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { findManyLeasesAlerts } from '../../lib/rest/leaseAPIClient'
import { useQuery } from '@tanstack/react-query'
import { Alert, Stack } from '@mantine/core'

function LeaseListAlerts () {
  const intl = useIntl()

  const { data } = useQuery({
    enabled: true,
    queryKey: ['leasesAlerts'],
    queryFn: () => findManyLeasesAlerts()
  })

  const alerts = useMemo(() => {
    const rows: { color?: string, message: string }[] = []

    if (!data) {
      return rows
    }
    if (data?.missingData) {
      rows.push({
        color: 'red',
        message: intl.formatMessage({
          id: 'lease_data_missing',
          defaultMessage: 'Certaines données sont manquantes dans les dossiers de location, utilisez le filtre "Données manquantes" pour les lister.'
        })
      })
    }
    if (data?.missingFiles) {
      rows.push({
        message: intl.formatMessage({
          id: 'lease_files_missing',
          defaultMessage: 'Certains fichiers n\'ont pas été chargés, utilisez le filtre "Fichiers manquants" pour les lister.'
        })
      })
    }
    return rows
  }, [data, intl])

  return <Stack>
    {alerts.map((alert) => (
      <Alert
        key={alert.message}
        color={alert.color || 'yellow'}
        icon={<FontAwesomeIcon icon={faExclamationTriangle} />}
      >
        {alert.message}
      </Alert>
    ))
    }
  </Stack>
}

export default LeaseListAlerts
